import React, { useState } from "react";
import {
  TextField,
  Button,
  Typography,
  Paper,
  Grid,
  InputAdornment,
} from '@mui/material';
import { GoogleOAuthProvider, useGoogleLogin } from '@react-oauth/google';
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import BottomImage from "../../components/LoginPages/bottomimage";
import HeaderApp from "../../components/LoginPages/header";
import "./style.css";
import { esignToolApi } from "../../services/esignApi";
import Loader from "../../components/Loader";

const VerifySignupOTP = () => {
    const [email, setEmail] = useState(localStorage.getItem("email") || "");
    const [otp, setOtp] = useState("");
    const [helperText, setHelperText] = useState({ email: "", otp: "", });
    const [errors, setErrors] = useState({ email: "", otp: "", });
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();
    const { user, isAuthenticated } = useSelector((state) => state.auth);
    const CLIENT_ID = "24660824558-kmbv1lh18n9e6urnqgrl32urhpql4in4.apps.googleusercontent.com";

    const GoogleLoginButton = () => {
        const login = useGoogleLogin({
            onSuccess: (tokenResponse) => {
                console.log('Login Success:', tokenResponse);
                fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
                    headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
                })
                .then((res) => res.json())
                .then((data) => console.log('User Info:', data))
                .catch((err) => console.error(err));
            },
            onError: () => {
                console.error('Login Failed');
            },
        });

        return (
            <Button
                onClick={() => login()}
                variant="outlined"
                className="googleSignINbtn"
            >
                <img src={`${process.env.PUBLIC_URL}/images/google.png`} alt="Google Logo" style={{ height: 23 }} />
                <span>Sign up with Google</span>
            </Button>
        );
    };
  
  // Email validation function
  const validateEmail = (value) => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(value);
  };

  const validateInputs = () => {
    let newErrors = {email: "", otp: "" };
    let newHelperText = {email: "", otp: "" };
    let isValid = true;
    
    if (!email) {
      newErrors.email = "Email is required";
      newHelperText.email = "Email is required";
      isValid = false;
    }

    if (!validateEmail(email) && email) {
        newErrors.email = "Invalid email address";
        newHelperText.email = "Invalid email address";
        isValid = false;
    }
    console.log(otp)
    
    // OTP Validation
    if (!otp) {
      newErrors.otp = "OTP is required";
      newHelperText.otp = "OTP is required";
      isValid = false;
    } else if (!/^\d{6}$/.test(otp)) {
      newErrors.otp = "Invalid OTP";
      newHelperText.otp = "OTP must be exactly 6 digits";
      isValid = false;
    }

    setErrors(newErrors);
    setHelperText(newHelperText);
    return isValid;
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "email") {
        setEmail(value);
        if (!validateEmail(value) && value) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                email: "Invalid email address",
            }));
            setHelperText((prevHelperText) => ({
                ...prevHelperText,
                email: "Invalid email address",
            }));

        } else {
            setErrors((prevErrors) => ({ ...prevErrors, email: "" }));
            setHelperText((prevHelperText) => ({ ...prevHelperText, email: "" }));
        }
    }
  };

    const handleSubmit = async () => {
        if (validateInputs()) {
            setLoader(true)
            try {
                const response = await esignToolApi.signupVerifyOtp(email, otp);
                console.log(response)
                setLoader(false)
                if (response && response.status===true) {
                    console.log("Navigating to /sign-in-details...");
                    setTimeout(() => {
                        navigate("/sign-in-details");
                    }, 100);
                } else {
                    console.error("Failed to verify otp:", response);
                }
            } catch (error) {
                setLoader(false)
                console.error("Error verifyotp:", error);
            }
        }
    };

  return (
    <>
      <HeaderApp type='signup' />
      <Grid container justifyContent="center" alignItems="center" sx={{display: "flex", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", zIndex: 1}}>
        <Grid item xs={12} sm={8} md={3.5}>
          <Paper elevation={3} sx={{ padding: "1.6em 3em", display: 'flex', flexDirection: 'column', alignItems: 'center', background:'#fffff', position: 'relative', zIndex: 1, borderRadius: "15px", boxShadow: "rgba(0, 0, 0, 0.1) 0px 7px 49px 0px" }}>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, fontSize: '24px', marginBottom: '2px' }}>
              Do the unimaginable!
            </Typography>
            <Typography gutterBottom sx={{ color: "#565555", fontSize: "18px", fontWeight: "400", mb: "12px" }}>Explore for free now!</Typography>
            
            <TextField
              placeholder="Email address"
              name="email"
              type="email"
              variant="outlined"
              fullWidth
              disabled
              value={email}
              onChange={(e) => {
                handleChange(e);
              }}
              error={!!errors.email}
              sx={{
                boxSizing: "border-box",
                borderRadius: "10px",
                backgroundColor: "#fff",
                borderColor: "#C0C0C0",
                borderWidth: "5px",
                "& .MuiOutlinedInput-root": {
                  borderColor: errors.email ? "#FF6666" : "#C0C0C0",
                  backgroundColor: errors.email ? "#FFF1F1" : "none",
                  "&:hover fieldset": {
                    borderColor: errors.email ? "#FF6666" : "#C0C0C0",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: errors.email ? "#FF6666" : "#C0C0C0",
                  },
                },
                "& .MuiFormHelperText-root": {
                  color: "#FF6666",
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img src={`${process.env.PUBLIC_URL}/images/mail.svg`} alt="Email Icon" style={{ width: 18, height: 18 }} />
                  </InputAdornment>
                ),
                sx: { borderRadius: "10px", height: 45, fontSize: "16px", fontWeight: email ? "600" : "400" },
              }}
            />

            {errors.email && (
              <Typography
                sx={{
                  color: "#FF6666",
                  fontSize: "12px",
                  mt: 0.5,
                  mb: 0,
                  marginRight: "auto"
                }}
              >
                {helperText.email}
              </Typography>
            )}
            
            
            <TextField
                placeholder="OTP"
                name="otp"
                type="number"
                variant="outlined"
                fullWidth
                value={otp}
                onKeyDown={(e) => {
                    if (["e", "E", "+", "-", "."].includes(e.key)) {
                      e.preventDefault();
                    }
                }}
                onPaste={(e) => {
                    const paste = e.clipboardData.getData('text');
                    if (!/^\d+$/.test(paste)) {
                      e.preventDefault();
                    }
                }}
                onChange={(e) => {
                    const input = e.target.value;

                    // Allow only digits and limit to 6 characters
                    if (/^\d{0,6}$/.test(input)) {
                      setOtp(input);
                      setErrors((prevErrors) => ({ ...prevErrors, otp: "" }));
                      setHelperText((prevHelperText) => ({ ...prevHelperText, otp: "" }));
                    }
                }}
                error={!!errors.otp}
                sx={{
                    mt: 2,
                    boxSizing: "border-box",
                    borderRadius: "10px",
                    backgroundColor: "#fff",
                    borderColor: "#C0C0C0",
                    borderWidth: "5px",
                    "& .MuiOutlinedInput-root": {
                        borderColor: errors.otp ? "#FF6666" : "#C0C0C0",
                        backgroundColor: errors.otp ? "#FFF1F1" : "none",
                        "&:hover fieldset": {
                        borderColor: errors.otp ? "#FF6666" : "#C0C0C0",
                        },
                        "&.Mui-focused fieldset": {
                        borderColor: errors.otp ? "#FF6666" : "#C0C0C0",
                        },
                    },
                    "& .MuiFormHelperText-root": {
                        color: "#FF6666",
                    },
                }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <img src={`${process.env.PUBLIC_URL}/images/otp.svg`} alt="Email Icon" style={{ width: 18, height: 18 }} />
                        </InputAdornment>
                    ),
                    sx: { borderRadius: "10px", height: 45, fontSize: "16px", fontWeight: otp ? "600" : "400" },
                }}
            />

            {!! errors.otp && (
                <Typography
                    sx={{
                        color: "#FF6666",
                        fontSize: "12px",
                        mt: 0.5,
                        mb: 0,
                        marginRight: "auto"
                    }}
                >
                    {helperText.otp}
                </Typography>
            )}


            <Button
              variant="contained"
              sx={{
                mt: 3,
                width: '100%',
                height: 45,
                color: "#fff",
                background: "#185CB7",
                textTransform: "none",
                fontSize: "16px",
                borderRadius: "10px",
                fontWeight: "600",
                "&:hover": { background: "#185CB7" },
              }}
              onClick={handleSubmit}
            >
              Sign up
            </Button>

            <Typography sx={{fontSize: "10px", color: "#7F7F7F", my: 2, textAlign: "center"}}>This site is protected by reCAPTCHA and the <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" style={{ color: "#185CB7"}}>Google Privacy Policy</a> and <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer" style={{ color: "#185CB7" }}>Terms of Service</a> apply.</Typography>
          </Paper>
        </Grid>
      </Grid>
      <BottomImage />
      {loader && <Loader />}
    </>
  );
};

export default VerifySignupOTP;
